import { Calendar, Clock, MapPin } from 'lucide-react';
import React from 'react';
import { typography } from '../../styles/typography';
import { Card } from '../ui';

const PatrolScheduleCard = ({ patrol, onClick, formatTimestamp }) => {
  return (
    <Card.Gradient
      className="p-6 cursor-pointer hover:shadow-lg transition-shadow"
      onClick={onClick}
    >
      <div className="flex flex-col gap-4">
        {/* QR Route Information */}
        <div className="flex flex-col gap-2">
          <div className="flex items-center gap-2">
            <MapPin className="w-5 h-5 text-green-600 flex-shrink-0" />
            <div className="flex-1">
              <span className="text-sm font-semibold text-gray-600">Start QR:</span>
              <span className={typography.h5} style={{ color: '#000000', marginLeft: '0.5rem' }}>
                {patrol.startQrName || patrol.start_qr_id || 'Unknown'}
              </span>
              {patrol.startQrAddress && (
                <p className="text-xs text-gray-500 mt-0.5 ml-7">
                  {patrol.startQrAddress}
                </p>
              )}
            </div>
          </div>
          <div className="flex items-center gap-2">
            <MapPin className="w-5 h-5 text-red-600 flex-shrink-0" />
            <div className="flex-1">
              <span className="text-sm font-semibold text-gray-600">End QR:</span>
              <span className={typography.h5} style={{ color: '#000000', marginLeft: '0.5rem' }}>
                {patrol.endQrName || patrol.end_qr_id || 'Unknown'}
              </span>
              {patrol.endQrAddress && (
                <p className="text-xs text-gray-500 mt-0.5 ml-7">
                  {patrol.endQrAddress}
                </p>
              )}
            </div>
          </div>
        </div>

        {/* Timestamps */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-2">
          <div className="flex items-start gap-2">
            <Calendar className="w-5 h-5 text-gray-600 mt-0.5 flex-shrink-0" />
            <div>
              <div className="text-sm font-semibold text-gray-600 mb-1">Start Time</div>
              <div className={typography.body1} style={{ color: '#000000' }}>
                {formatTimestamp(patrol.patrol_start_timestamp || patrol.start_timestamp)}
              </div>
            </div>
          </div>
          <div className="flex items-start gap-2">
            <Clock className="w-5 h-5 text-gray-600 mt-0.5 flex-shrink-0" />
            <div>
              <div className="text-sm font-semibold text-gray-600 mb-1">End Time</div>
              <div className={typography.body1} style={{ color: '#000000' }}>
                {formatTimestamp(patrol.patrol_end_timestamp || patrol.end_timestamp)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Card.Gradient>
  );
};

export default PatrolScheduleCard;

